// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__MxBSr","row":"ProcedureTreatmentSummary_row__1wvrv"};